<template>
  <div class="bg-white p-4 rounded-lg shadow mt-4">
    <div class="flex flex-row items-center">
      <div
        class="w-8 h-8 rounded-full flex items-center justify-center"
        :class="`bg-${circle_color}`"
      >
        <img class="w-icon h-icon" :src="icon" />
      </div>

      <span class="font-semibold ml-2" :class="`text-${text_color}`">
        {{ title }}
      </span>
    </div>
    <div class="mt-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BalanceGroupControl",
  props: {
    title: {
      type: String,
      default: "Savings",
    },
    icon: {
      type: String,
      default: () =>
        new URL(
          "@/assets/icons/papsi_savings.svg",
          import.meta.url
        ).href,
    },
    text_color: {
      type: String,
      default: "primary",
    },
    circle_color: {
      type: String,
      default: "primary-light",
    },
  },
};
</script>

<style></style>